import React from 'react';

export default function Problem() {
  return (
    <section className="section problem">
      <h2 className="section__title">You don't need more textbook English.</h2>
      <p className="problem__body">
        You need to know what to say when you're ordering food, calling the bank,
        visiting a doctor, rescheduling an appointment, returning a package, or making
        small talk. ConvoLines helps you practice those moments before they happen.
      </p>
    </section>
  );
}
